<template>
    <tr>
      <td>
        <app-link
          :to="{ name: 'DatasetDetailsDataset', query: { locale: $route.query.locale }, params: { ds_id: comment.resource.resourceId } }">
          {{ comment.resource.resourceId }}
        </app-link>
      </td>
      <td>
        {{ formatDatetime(comment.lastUpdate) }}
      </td>
      <td>
        <span>{{ comment.content }}</span>
      </td>
      <td>
        <font-awesome-icon v-if="comment.isReported" :icon="['fa', 'exclamation-triangle']"  class="material-icons" style="color: rgb(220, 0, 0);" />
      </td>
      <td class="buttonWrapper d-flex flex-column">
        <button v-if="mode=='unpublished'"
          type="button"
          class="btn btn-action"
          @click="handlePublish(comment.id)"
        >
          {{ $t('message.dataupload.menu.publish') }}
        </button>
        <button v-if="mode=='published'"
          type="button"
          class="btn btn-action"
          @click="handleUnpublish(comment.id)"
        >
            Unpublish
        </button>
        <button v-if="comment.isReported"
          type="button"
           class="btn btn-action"
          @click="handleWithdrowingReport(comment.id)"
        >
        Mark safe
        </button>
        <button
          type="button"
           class="btn btn-outline-danger"
          @click="handleDelete(comment.id)"
        >
        {{ $t('message.dataupload.menu.delete') }}
        </button>
      </td>
    </tr>
</template>

<script setup>
import { AppLink } from "@piveau/piveau-hub-ui-modules";

defineProps({
    comment: Object,
    mode: String,
    formatDatetime: Function,
    handlePublish: Function,
    handleUnpublish: Function,
    handleDelete: Function,
    handleWithdrowingReport: Function,
})
</script>

<style scoped>
/* .nav-item {
  width: 50%;
} */
table {
  margin-top: 50px !important;
  margin-left: 0px !important;
}
.mod-overview {
  min-height: 60vh;
  margin-bottom: 60px !important;
}

.btn-action {
  border: solid 1px #3f3f3f;
}

.btn-action:hover {
  border: solid 1px #3f3f3f;
  background-color: #3f3f3f;
  color: #fff;
}

.buttonWrapper button {
  margin: 0.2rem;
  max-height: 40px;
  width: 100px;
}

.buttonWrapper {
  width: 100%;
  display: flex;
}

th,
td {
  padding: 1rem;
  text-align: center;

}

tr {
  padding: 1rem;
  border-bottom: 1px solid lightgray;
}

thead {
  border-bottom: 1px solid lightgray;
}
</style>
